
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../store/httpClient";
import { AddressDto } from "@/dtos/addressDto";
import { AddressType } from "@/dtos/addressType";
import rules from "@/store/rules";

@Component({
	components: {},
})
export default class EditAddressComponent extends Vue {
	@Prop()
	private address!: AddressDto;
	@Prop()
	private addressType!: AddressType;
	@Prop()
	private orderId!: number;
	private isLoading: boolean = false;
	private validForm: boolean = true;
	private customerPersonalType: AddressType = AddressType.CustomerPersonal;
	private customerDeliveryType: AddressType = AddressType.CustomerDelivery;
	private customerInvoiceType: AddressType = AddressType.CustomerInvoice;
	private orderDeliveryType: AddressType = AddressType.OrderDelivery;
	private orderInvoiceType: AddressType = AddressType.OrderInvoice;
	private requiredRule = rules.requiredRule;
	private addressOptionalStringRule = rules.addressOptionalStringRule;
	private addressRequiredStringRule = rules.addressRequiredStringRule;
	private requiredEmailRule = rules.requiredEmailRule;
	private optionalEmailRule = rules.optionalEmailRule;

	private correctPlzRule = [
		(v: string) =>
			(this.address.country !== "Deutschland" &&
				this.address.country !== "Schweiz" &&
				this.address.country !== "Liechtenstein") ||
			(this.address.country === "Deutschland" &&
				v.length === 5 &&
				parseInt(v) >= 1000 &&
				parseInt(v) <= 99999) ||
			((this.address.country === "Schweiz" || this.address.country === "Liechtenstein") &&
				v.length === 4 &&
				parseInt(v) >= 1000 &&
				parseInt(v) <= 9999) ||
			"Muss eine gültige PLZ sein.",
	];

	private async saveAddress() {
		try {
			this.isLoading = true;

			switch (this.addressType) {
				case AddressType.CustomerPersonal:
					await httpClient().post(`Customer/SaveCustomerGenericAddress`, this.address);
					break;
				case AddressType.CustomerInvoice:
				case AddressType.CustomerDelivery:
					await httpClient().post(`Customer/AddOrUpdateCustomerAddress`, this.address);
					break;
				case AddressType.OrderInvoice:
					await httpClient().post(
						`CustomerOrder/SaveOrderInvoiceAddress?orderId=${this.orderId}`,
						this.address
					);
					break;
				case AddressType.OrderDelivery:
					await httpClient().post(
						`CustomerOrder/SaveOrderDeliveryAddress?orderId=${this.orderId}`,
						this.address
					);
					break;
				default:
					throw "Wrong AddressType.";
			}

			this.$store.commit("setSnackbarText", "Adresse wurde erfolgreich geändert.");
			this.$emit("saved", this.address);
			this.$emit("closed");
		} catch (err) {
			console.log(err);
			this.$store.commit("setSnackbarErrorText", "Speichern der Adresse fehlgeschlagen.");
		} finally {
			this.isLoading = false;
		}
	}
}
